"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluralize = void 0;
const pluralize = (word, amount, variant) => amount > 1 ? variant || `${word}s` : word;
exports.pluralize = pluralize;
//# sourceMappingURL=pluralize.js.map